import { View, Text, Platform } from "react-native";
import { GuidePageHeader, GuideCard, GuideStep, GuideTip, GuideNav, getGuideNav } from "./_components";

const PAGE_HREF = "/(web)/guide/challenges";

export default function ChallengesPage() {
  if (Platform.OS !== "web") return null;
  const nav = getGuideNav(PAGE_HREF);

  return (
    <View>
      <GuidePageHeader
        icon="flash"
        title="Uitdagingen"
        subtitle="Voltooi uitdagingen en opdrachten om punten te verdienen voor je team!"
        color="#F59E0B"
      />

      {/* Soorten uitdagingen */}
      <Text className="text-xl font-bold text-gray-900 mb-4">Soorten Uitdagingen</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        De commissie kan verschillende soorten uitdagingen aanmaken. Elke uitdaging heeft een 
        beschrijving, puntenwaarde en soms een deadline.
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="camera"
          title="Foto-opdracht"
          description="Maak een foto die aan de opdracht voldoet. Bijvoorbeeld: 'Maak een grappige groepsfoto met je team'. De foto wordt ter beoordeling naar de commissie gestuurd."
          color="#8B5CF6"
        />
        <GuideCard
          icon="help-circle"
          title="Quiz-uitdaging"
          description="Beantwoord een reeks vragen correct. Dit kan een kennisquiz zijn over de familie of een ander onderwerp."
          color="#3B82F6"
        />
        <GuideCard
          icon="location"
          title="Locatie-uitdaging"
          description="Ga naar een specifieke locatie en bewijs dat je er bent (via GPS of foto). Perfect voor speurtocht-achtige opdrachten."
          color="#10B981"
        />
        <GuideCard
          icon="checkbox"
          title="Taak-uitdaging"
          description="Voltooi een specifieke taak, zoals 'Help met koken' of 'Organiseer een activiteit'. De commissie beoordeelt je inzending."
          color="#F59E0B"
        />
        <GuideCard
          icon="extension-puzzle"
          title="Puzzel-uitdaging"
          description="Los een puzzel op, zoals een raadsel, woordzoeker of logica-puzzel."
          color="#EC4899"
        />
      </View>

      {/* Hoe het werkt */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Hoe werkt het?</Text>
      
      <View className="mb-6">
        <GuideStep
          step={1}
          title="Uitdaging bekijken"
          description="Open de uitdaging vanuit het overzicht of via een melding. Lees de beschrijving en bekijk hoeveel punten het waard is."
          color="#F59E0B"
        />
        <GuideStep
          step={2}
          title="Inzending maken"
          description="Maak een foto, beantwoord vragen of voltooi de taak. Sommige uitdagingen vereisen dat je op een specifieke locatie bent."
          color="#F59E0B"
        />
        <GuideStep
          step={3}
          title="Inzending versturen"
          description="Verstuur je inzending via de app. Bij foto-opdrachten upload je de foto direct."
          color="#F59E0B"
        />
        <GuideStep
          step={4}
          title="Beoordeling"
          description="De commissie beoordeelt je inzending. Je ontvangt een melding of je inzending is goedgekeurd of afgekeurd."
          color="#F59E0B"
        />
        <GuideStep
          step={5}
          title="Punten ontvangen"
          description="Bij goedkeuring worden de punten automatisch aan je team toegevoegd. Bij afkeuring kun je soms opnieuw insturen."
          color="#F59E0B"
        />
      </View>

      <GuideTip title="Meldingen bij uitdagingen">
        Je ontvangt een push-melding wanneer er een nieuwe uitdaging beschikbaar is, 
        en wanneer je inzending is beoordeeld (goedgekeurd of afgekeurd).
      </GuideTip>

      {/* Opdrachten met secties */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Opdrachten met Secties</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Naast losse uitdagingen kan de commissie ook uitgebreide opdrachten aanmaken met meerdere 
        secties. Dit zijn grotere, meerdelige taken die teams samen moeten voltooien.
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="list"
          title="Meerdere secties"
          description="Een opdracht kan bestaan uit meerdere secties die elk hun eigen instructies en puntenwaarde hebben. Voltooide secties worden afgevinkt."
          color="#7C3AED"
        />
        <GuideCard
          icon="people"
          title="Teamopdrachten"
          description="Opdrachten zijn vaak bedoeld voor het hele team. Werk samen om alle secties te voltooien en maximaal punten te verdienen."
          color="#EC4899"
        />
        <GuideCard
          icon="trophy"
          title="Bonus punten"
          description="Sommige opdrachten bieden bonuspunten als je alle secties voltooit of als je de opdracht als eerste team afrondt."
          color="#F59E0B"
        />
      </View>

      {/* Deadlines */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Deadlines</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Uitdagingen kunnen een deadline hebben. Na de deadline kun je geen inzending meer doen. 
        De deadline wordt getoond bij de uitdaging. Let op: sommige uitdagingen zijn maar 
        kort beschikbaar!
      </Text>

      <GuideTip variant="warning" icon="alarm" title="Let op de deadline!">
        Uitdagingen met een korte deadline zijn vaak meer punten waard. Houd de meldingen 
        in de gaten zodat je geen uitdaging mist!
      </GuideTip>

      <GuideNav {...nav} />
    </View>
  );
}
